import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OverviewCardBodyQueryVariables = Types.Exact<{
  companyId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type OverviewCardBodyQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly mediaplanType?: Types.AccountsCompanyMediaplanType | null, readonly graphStats: ReadonlyArray<{ readonly __typename?: 'YalperGraphStat', readonly date: string, readonly spent: number, readonly clicks: number, readonly impressions: number }>, readonly mediaplanStats: ReadonlyArray<{ readonly __typename?: 'YalperMediaplanStat', readonly collectedOn: string, readonly bounces: number, readonly comments: number, readonly impressions: number, readonly conversions: number, readonly likes: number, readonly reach: number, readonly revenue: number, readonly shares: number, readonly spent: number, readonly videoComplete: number }>, readonly mediaplans: ReadonlyArray<{ readonly __typename?: 'AccountsMediaplan', readonly id: string, readonly budget: number, readonly startOn: string, readonly endOn?: string | null, readonly type: Types.AccountsMediaplanType, readonly repeat?: Types.AccountsMediaplanRepeat | null, readonly startOnPeriodBegin?: boolean | null, readonly kpis?: ReadonlyArray<{ readonly __typename?: 'AccountsKpi', readonly name: Types.AccountsKpiName, readonly value: string | number, readonly primary: boolean }> | null }> } | null } | null };


export const OverviewCardBodyDocument = gql`
    query OverviewCardBody($companyId: ID, $startDate: Date!, $endDate: Date!) {
  currentUser {
    company(id: $companyId) {
      id
      mediaplanType
      graphStats(endDate: $endDate, startDate: $startDate) {
        date
        spent
        clicks
        impressions
      }
      mediaplanStats(endDate: $endDate, startDate: $startDate) {
        collectedOn
        bounces
        comments
        impressions
        conversions
        likes
        reach
        revenue
        shares
        spent
        videoComplete
      }
      mediaplans(endDate: $endDate, startDate: $startDate) {
        id
        budget
        startOn
        endOn
        type
        repeat
        startOnPeriodBegin
        kpis {
          name
          value
          primary
        }
      }
    }
  }
}
    `;

/**
 * __useOverviewCardBodyQuery__
 *
 * To run a query within a React component, call `useOverviewCardBodyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewCardBodyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewCardBodyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useOverviewCardBodyQuery(baseOptions: Apollo.QueryHookOptions<OverviewCardBodyQueryPage, OverviewCardBodyQueryVariables> & ({ variables: OverviewCardBodyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverviewCardBodyQueryPage, OverviewCardBodyQueryVariables>(OverviewCardBodyDocument, options);
      }
export function useOverviewCardBodyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverviewCardBodyQueryPage, OverviewCardBodyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverviewCardBodyQueryPage, OverviewCardBodyQueryVariables>(OverviewCardBodyDocument, options);
        }
export function useOverviewCardBodySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OverviewCardBodyQueryPage, OverviewCardBodyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OverviewCardBodyQueryPage, OverviewCardBodyQueryVariables>(OverviewCardBodyDocument, options);
        }
export type OverviewCardBodyQueryHookResult = ReturnType<typeof useOverviewCardBodyQuery>;
export type OverviewCardBodyLazyQueryHookResult = ReturnType<typeof useOverviewCardBodyLazyQuery>;
export type OverviewCardBodySuspenseQueryHookResult = ReturnType<typeof useOverviewCardBodySuspenseQuery>;
export type OverviewCardBodyQueryResult = Apollo.QueryResult<OverviewCardBodyQueryPage, OverviewCardBodyQueryVariables>;